/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramParametersControllerFindDynamicParametersByOptionQueryResponse,
  TelegramParametersControllerFindDynamicParametersByOptionPathParams,
  TelegramParametersControllerFindDynamicParametersByOptionQueryParams,
} from '../../types/TelegramParametersControllerFindDynamicParametersByOption.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramParametersFindDynamicParametersByOption } from '../../methods/telegramParametersFindDynamicParametersByOption.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramParametersFindDynamicParametersByOptionQueryKey = (
  id: TelegramParametersControllerFindDynamicParametersByOptionPathParams['id'],
  categoryId: TelegramParametersControllerFindDynamicParametersByOptionPathParams['categoryId'],
  params: TelegramParametersControllerFindDynamicParametersByOptionQueryParams,
) =>
  [
    { url: '/api/telegram/parameters/:id/dynamic/:categoryId', params: { id: id, categoryId: categoryId } },
    ...(params ? [params] : []),
  ] as const;

export type TelegramParametersFindDynamicParametersByOptionQueryKey = ReturnType<
  typeof telegramParametersFindDynamicParametersByOptionQueryKey
>;

export function telegramParametersFindDynamicParametersByOptionQueryOptions(
  id: TelegramParametersControllerFindDynamicParametersByOptionPathParams['id'],
  categoryId: TelegramParametersControllerFindDynamicParametersByOptionPathParams['categoryId'],
  params: TelegramParametersControllerFindDynamicParametersByOptionQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramParametersFindDynamicParametersByOptionQueryKey(id, categoryId, params);
  return queryOptions<
    TelegramParametersControllerFindDynamicParametersByOptionQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramParametersControllerFindDynamicParametersByOptionQueryResponse,
    typeof queryKey
  >({
    enabled: !!(id && categoryId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramParametersFindDynamicParametersByOption(id, categoryId, params, config);
    },
  });
}

/**
 * {@link /api/telegram/parameters/:id/dynamic/:categoryId}
 */
export function useTelegramParametersFindDynamicParametersByOption<
  TData = TelegramParametersControllerFindDynamicParametersByOptionQueryResponse,
  TQueryData = TelegramParametersControllerFindDynamicParametersByOptionQueryResponse,
  TQueryKey extends QueryKey = TelegramParametersFindDynamicParametersByOptionQueryKey,
>(
  id: TelegramParametersControllerFindDynamicParametersByOptionPathParams['id'],
  categoryId: TelegramParametersControllerFindDynamicParametersByOptionPathParams['categoryId'],
  params: TelegramParametersControllerFindDynamicParametersByOptionQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramParametersControllerFindDynamicParametersByOptionQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? telegramParametersFindDynamicParametersByOptionQueryKey(id, categoryId, params);

  const query = useQuery(
    {
      ...telegramParametersFindDynamicParametersByOptionQueryOptions(id, categoryId, params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
